// extracted by mini-css-extract-plugin
export default {"calendar":"RichemontCalendar_calendar__EcgSY"};